import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@shopify/polaris/build/esm/styles.css";
import "./index.css";
import configService from "./services/config/config-service.ts";
import { getEmbeddedState } from "./utils/app-bridge/app-bridge-helpers.ts";
import { setAxiosBaseUrl } from "./services/api/axiosHelpers.ts";

const render = () => {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Aborting....No root element found.");
  }

  const { isEmbedded } = getEmbeddedState(
    configService.appConfig.shopifyApiKey,
  );
  const isDetachedMode = configService.appConfig.useDetached === "true";
  if (!isEmbedded && isDetachedMode) {
    console.info("Rendering detached mode for local testing/debugging...");
  }

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

try {
  await configService.load();
  setAxiosBaseUrl();
  render();
} catch (_err) {
  console.error("error occurred while loading app config", _err);
}
